import { Route, Switch } from 'react-router';
import SearchTimesheet from './search';
import ViewTimesheet from './view';

const TimesheetSearch = () => {
  return (
    <Switch>
      <Route exact path='/admin/timesheetSearch' component={SearchTimesheet} />
      <Route exact path='/admin/timesheetSearch/:id' component={ViewTimesheet} />
    </Switch>
  );
};

export default TimesheetSearch;